import { motion } from "framer-motion";
import { Heart, MapPin, TrendingUp, Eye, Phone, Star, ArrowRight, Users, Camera, Calendar } from "lucide-react";

const STATS = [
  { value: "+130%", label: "Richieste info 18-34 anni", icon: TrendingUp },
  { value: "87%", label: "Esplorano virtualmente prima", icon: Eye },
  { value: "5-10x", label: "Tempo sul profilo Google", icon: Users },
  { value: "28%", label: "Prenotano entro 24h da mobile", icon: Calendar },
];

const BIG_PLAYERS = [
  { name: "Villa PoggiAlto", zone: "Siena", note: "Matrimoni esclusivi, colline senesi" },
  { name: "Borgo di Vignamaggio", zone: "Chianti", note: "Vigneti, matrimoni all'aperto" },
  { name: "Abbazia di San Galgano", zone: "Siena", note: "Rovine gotiche, location iconica" },
  { name: "Certosa di Pontignano", zone: "Chianti", note: "Abbazia storica per grandi eventi" },
  { name: "Palazzo Patrizi", zone: "Siena centro", note: "Soffitti affrescati, grandi numeri" },
  { name: "Villa Valentini Bonaparte", zone: "Montepulciano", note: "Panorami eleganti, Val d'Orcia" },
  { name: "Villa Cora", zone: "Firenze", note: "Lusso, vista panoramica, eventi esclusivi" },
  { name: "Il Salviatino", zone: "Firenze", note: "Resort collina, matrimoni premium" },
  { name: "Podere la Strega", zone: "Siena", note: "Casale '700, collina con vista" },
  { name: "Tenuta di Monaciano", zone: "Chianti", note: "Tenuta esclusiva tra i vigneti" },
];

const WA_MSG = "Ciao Riccardo! Ho una location per matrimoni/eventi in Toscana e vorrei il Virtual Tour 360 per mostrare gli spazi alle coppie.";

export default function LandingWedding() {
  return (
    <div className="min-h-screen bg-[#0c1220] text-white">
      <div className="max-w-4xl mx-auto px-4 py-10">

        {/* Hero */}
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#EA4335]/10 border border-[#EA4335]/30 text-[#EA4335] text-sm font-bold mb-6">
            <Heart className="w-4 h-4" /> WEDDING VENUES E LOCATION EVENTI
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight mb-6">
            Le coppie scelgono <br />
            <span className="text-[#EA4335]">dal divano.</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            La sposa del 2026 non visita 20 location. Ne visita 3 — le 3 che l'hanno fatta innamorare su Google.
            <strong className="text-white"> Se la tua villa non ha un Virtual Tour, non sei tra quelle 3.</strong>
          </p>
        </motion.div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {STATS.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }}
              className="bg-white/5 border border-white/10 rounded-2xl p-5 text-center">
              <s.icon className="w-5 h-5 text-[#EA4335] mx-auto mb-2" />
              <div className="text-3xl font-black text-white">{s.value}</div>
              <div className="text-xs text-gray-400 mt-1">{s.label}</div>
            </motion.div>
          ))}
        </div>

        {/* Pain Point */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}
          className="bg-[#EA4335]/10 border border-[#EA4335]/30 rounded-2xl p-6 mb-12">
          <h2 className="text-xl font-bold text-[#EA4335] mb-3">Il mercato wedding in Toscana e' feroce</h2>
          <p className="text-gray-300 text-base leading-relaxed">
            Matrimonio.com, TheKnot, Instagram — le coppie (soprattutto americane e inglesi) cercano
            <strong className="text-white"> "wedding venue Tuscany"</strong> e decidono in 60 secondi.
            <br /><br />
            Le foto piatte non bastano piu. Un Virtual Tour 360 fa <strong className="text-white">entrare la coppia nella tua villa</strong>,
            fargli vedere il giardino, la sala, la vista. Si innamorano prima di chiamarti.
            E quando chiamano, <strong className="text-white">hanno gia deciso.</strong>
          </p>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.4 }}
          className="bg-gradient-to-r from-[#EA4335]/20 to-[#FBBC04]/20 border border-[#EA4335]/30 rounded-2xl p-8 text-center mb-12">
          <h2 className="text-2xl font-black mb-2">Pacchetti da €99 — Deducibili al 100%</h2>
          <p className="text-gray-300 mb-6">Il costo di un centrotavola. Ma lavora per te 365 giorni l'anno.</p>
          <a href={`https://wa.me/+393273839782?text=${encodeURIComponent(WA_MSG)}`}
            className="inline-flex items-center gap-2 bg-[#EA4335] hover:bg-[#d33426] text-white font-bold px-8 py-4 rounded-full text-lg transition-all hover:scale-105">
            <Phone className="w-5 h-5" /> Scrivimi su WhatsApp
          </a>
          <p className="text-gray-500 text-xs mt-3">Riccardo Rossi — Fotografo Google Certificato dal 2016</p>
        </motion.div>

        {/* Big Players */}
        <div className="mb-12">
          <h2 className="text-2xl font-black mb-2">Le Location Top della Toscana</h2>
          <p className="text-gray-400 text-base mb-6">Ville, borghi, abbazie — <strong className="text-[#EA4335]">quasi nessuna ha un Virtual Tour 360 su Google.</strong> La prima che lo fa, domina le ricerche wedding.</p>
          <div className="grid gap-3">
            {BIG_PLAYERS.map((b, i) => (
              <motion.div key={i} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.5 + i * 0.05 }}
                className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-xl px-5 py-3">
                <Heart className="w-5 h-5 text-[#EA4335] flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="text-white font-bold text-base">{b.name}</div>
                  <div className="text-gray-400 text-xs">{b.note}</div>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-500 flex-shrink-0">
                  <MapPin className="w-3 h-3" /> {b.zone}
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center">
          <a href={`https://wa.me/+393273839782?text=${encodeURIComponent(WA_MSG)}`}
            className="inline-flex items-center gap-2 bg-[#34A853] hover:bg-[#2d9249] text-white font-bold px-8 py-4 rounded-full text-lg transition-all hover:scale-105">
            Fai innamorare le coppie <ArrowRight className="w-5 h-5" />
          </a>
          <p className="text-gray-600 text-xs mt-4">schedabusiness.it — Fotografo Google Street View Certificato dal 2016</p>
        </div>
      </div>
    </div>
  );
}
